import { literals, toLiteral } from 'util/dom/mq';

const columnsByBreakpoint = {
    [literals.XS]: 1,
    [literals.SM]: 8,
    [literals.MD]: 12,
    [literals.LG]: 16,
    [literals.XL]: 20,
    [literals.XXL]: 24,
};

export default function generate(width) {
    return columnsByBreakpoint[toLiteral(width)];
}
